// extracted by mini-css-extract-plugin
export var biggerform = "form-module--biggerform--QqgHJ";
export var fillwrapper = "form-module--fillwrapper--JjzMf";
export var formbody = "form-module--formbody--oGMdA";
export var topbottommargin = "form-module--topbottommargin--36Zex";